import React from 'react';
import PropTypes from 'prop-types';
import { Item, Menu, MenuContainer } from '../styles';

const MenuFlaps = (props) => {
  const {
    project,
    activeItem,
    onClickMenuItem,
  } = props;

  const {
    participantsSource,
  } = project;

  return (
    <MenuContainer>
      <Menu pointing secondary stackable>
        {participantsSource === 'playbook' && (
          <>
            <Item
              name="demographics"
              active={activeItem === 'demographics'}
              onClick={onClickMenuItem}
            />
            <Item
              name="employment"
              active={activeItem === 'employment'}
              onClick={onClickMenuItem}
            />
          </>
        )}

        <Item
          name="screener"
          active={activeItem === 'screener'}
          onClick={onClickMenuItem}
        />
        <Item
          name="consent-form"
          active={activeItem === 'consent-form'}
          onClick={onClickMenuItem}
        />
      </Menu>
    </MenuContainer>
  );
};

MenuFlaps.propTypes = {
  activeItem: PropTypes.string.isRequired,
  onClickMenuItem: PropTypes.func.isRequired,
  project: PropTypes.shape().isRequired,
};

export default MenuFlaps;
